import { getApiClient } from './axios-config';

/**
 * Authentication API Service
 * Handles all API calls related to authentication
 */
class AuthAPI {
  /**
   * Login user
   * @param {string} email - User email
   * @param {string} password - User password
   * @returns {Promise<Object>} Login response with token and user data
   */
  static async login(email, password) {
    const apiClient = getApiClient(); // No token needed for login
    const response = await apiClient.post('/api/users/login', {
      email,
      password,
    });
    // Login endpoint returns data directly (not wrapped in ResponseHelper format)
    return response.data;
  }

  /**
   * Logout user
   * @returns {Promise<Object>} Logout response
   */
  static async logout() {
    const apiClient = getApiClient(); // No token needed for logout
    const response = await apiClient.post('/api/users/logout');
    return response.data;
  }

  /**
   * Update password
   * @param {string} currentPassword - Current password
   * @param {string} newPassword - New password
   * @param {string} checkPassword - Verify password (must match newPassword)
   * @param {string} token - JWT authentication token
   * @returns {Promise<Object>} Update result
   */
  static async updatePassword(
    currentPassword,
    newPassword,
    checkPassword,
    token
  ) {
    const apiClient = getApiClient(token);
    const response = await apiClient.put('/api/users/password', {
      current_password: currentPassword,
      new_password: newPassword,
      check_password: checkPassword,
    });
    // Password update endpoint returns data directly (not wrapped in ResponseHelper format)
    return response.data;
  }
}

export default AuthAPI;
